/**
 * TanStack Query hooks for `composite-fraud-score-combine-multiple-vendor-scor`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	compositeFraudScoreCombineMultipleVendorScorQueryKeys,
	type CreateCompositeFraudScoreCombineMultipleVendorScorBody,
	type ListCompositeFraudScoreCombineMultipleVendorScorResponse,
	type CompositeFraudScoreCombineMultipleVendorScorRow,
} from "./api";

export function useCompositeFraudScoreCombineMultipleVendorScorList(): UseQueryResult<ListCompositeFraudScoreCombineMultipleVendorScorResponse, Error> {
	return useQuery({
		queryKey: compositeFraudScoreCombineMultipleVendorScorQueryKeys.list(),
		queryFn: list,
	});
}

export function useCompositeFraudScoreCombineMultipleVendorScorCreate(): UseMutationResult<CompositeFraudScoreCombineMultipleVendorScorRow, Error, CreateCompositeFraudScoreCombineMultipleVendorScorBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: compositeFraudScoreCombineMultipleVendorScorQueryKeys.all });
		},
	});
}

export function useCompositeFraudScoreCombineMultipleVendorScorDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: compositeFraudScoreCombineMultipleVendorScorQueryKeys.all });
		},
	});
}
